module.exports = __webpack_public_path__ + "static/media/6.ce136804.JPG";